define([
    "./ganttChartModule",
    "./nlgGanttChart"
], function () {
});